import { initializeVue } from "@/core/app-setup";
import { dispatchOpenHelpdeskArticle, dispatchOpenHelpdeskConversation, dispatchToggleIntercom } from "@/common/helpers/custom-events";
import IntercomBeaconView from "@/experiences/intercom/views/IntercomBeaconView.vue";
import { h } from "vue";
// `triggerHtml` is the custom-element's original light-DOM content, captured before mount replaces it -
// see the IntercomBeacon custom element in custom-html-tags.js. Rendered via a `display: contents` wrapper
// so it doesn't introduce an extra layout box around the custom trigger markup.
window.initializeIntercomBeacon = (elSelector, rootProps, triggerHtml) => {
    const slots = triggerHtml
        ? { default: () => h("div", { style: "display: contents", innerHTML: triggerHtml }) }
        : undefined;
    return initializeVue(elSelector, IntercomBeaconView, { rootProps, slots });
};
window.recollectiveHelpdesk = {
    // JSP-facing equivalent of SupportBeacon.article(id) - boots the Messenger if needed, then opens the article.
    openArticle: (articleId) => {
        dispatchOpenHelpdeskArticle({ articleId });
    },
    // Boots the Messenger if needed, then opens a new conversation, optionally prefilled with `message`.
    openConversation: (message) => {
        dispatchOpenHelpdeskConversation({ message });
    },
    // JSP-facing equivalent of SupportBeacon.open()/close() - boots the Messenger if needed, then toggles it.
    toggle: () => {
        dispatchToggleIntercom();
    }
};
